import React, {useEffect} from "react"
import {connect} from "react-redux";
import * as layoutService from "../view/layoutService";
import {withMainLayout} from "../view/LayoutHOCs";
import {InfoBoxes} from "../info-boxes/InfoBoxes";
import {useHistory} from "react-router-dom";
import ReportsTableSection from "./ReportsTableSection";

const breadcrumbs = [
    {
        text: "Home",
        redirectTo: "/",
        iconClassName: "icon-home"
    },
    {
        text: "Reports",
        redirectTo: "/reports",
    }
]

function ReportsPage() {

    const history = useHistory();

    useEffect(() => {
        layoutService.setPageTitle('Reports')
        layoutService.setBreadcrumbs(breadcrumbs)
    }, [history.location])

    return (
        <>
            <InfoBoxes/>
            <ReportsTableSection/>
        </>
    );
}


export default withMainLayout(connect()(ReportsPage));